import React from "react";
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import classes from "./ImagePreview.module.css";

const ImagePreview = ({ src, onRemove, removeAriaLabel, width, height }) => (
    <div className={classes.PreviewBlock}>
        <div className={classes.PreviewWrap} style={{ width, height }}>
            <img src={src} alt="" className={classes.PreviewImg} />
            {onRemove && (
                <div className={classes.Overlay} >
                    <Icon className={classes.DeleteIcon} name={iconsList.delete} size="28px" color="#fff" aria-label={removeAriaLabel} onClick={onRemove} />
                </div>
            )}

        </div>
    </div>
);

export default ImagePreview;
